import dayjs from 'dayjs';

export const format = (date: string | Date, format = 'YYYY-MM-DD') => {
    return date ? dayjs(date).format(format) : null;
}

export const formatTime = (sec_num: number) => {
    let hours: string | number = Math.floor(sec_num / 3600);
    let minutes: string | number = Math.floor((sec_num - hours * 3600) / 60);
    let seconds: string | number = Math.floor(sec_num - hours * 3600 - minutes * 60);

    hours = hours < 10 ? (hours > 0 ? '0' + hours : 0) : hours;

    if (minutes < 10) {
        minutes = '0' + minutes;
    }
    if (seconds < 10) {
        seconds = '0' + seconds;
    }
    return (hours !== 0 ? hours + ':' : '') + minutes + ':' + seconds;
}

export const asSeconds = (time: string) => {
    const [hours, minutes, seconds] = time.split(':');
    return Number(hours) * 60 * 60 + Number(minutes) * 60 + Number(seconds);
}
